import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import { apiPaths } from 'app/services/api';

const Users = () => {
  const columns = [
    {
      name: 'Name',
      key: 'last_name',
      render: (record, i) => <div>{`${record.first_name} ${record.last_name}`}</div>
    },
    { name: 'Mobile', key: 'mobile_number' },
    { name: 'Role', key: 'roles' },
    {
      name: 'Create Date',
      key: 'created_at',
      type: 'date',
      sort: true
    }
  ];

  const filtersOn = [
    { name: 'Mobile', key: 'mobile_number' },
    { name: 'Name', key: 'name' }
  ];

  return (
    <div className="m-sm-30">
      <div className="mb-sm-30">
        {/* <Breadcrumb
              routeSegments={[
                  { name: 'Material', path: '/material' },
                  { name: 'Table' },
              ]}
          /> */}
      </div>
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Users"
          path="users"
          apipath={apiPaths.USERS}
          columns={columns}
          filtersOn={filtersOn}
          hideActions={['delete', 'view']}
        />
      </SimpleCard>
    </div>
  );
};

export default Users;
